module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCond.e875399.ttf";